import { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeHigh, faVolumeXmark } from '@fortawesome/free-solid-svg-icons';
import './MusicToggle.css';

const audio = new Audio('/audio/Blue_Hour_Porch.mp3');
audio.loop = true;

const MusicToggle: React.FC = () => {
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    return () => {
      audio.pause();
    };
  }, []);

  const toggle = () => {
    if (playing) {
      audio.pause();
    } else {
      audio.play();
    }
    setPlaying(!playing);
  };

  return (
    <button className="music-toggle" onClick={toggle} aria-label="Toggle music">
      <FontAwesomeIcon icon={playing ? faVolumeHigh : faVolumeXmark} />
    </button>
  );
};

export default MusicToggle;
